export default function(data, options) {
  var self = this;
  self.options = {
    anonymous: false
  };

  const __construct = function (data, opts) {
    console.log('FileEntryModel constructor called with data ' + data + ' and options ' + opts);
    self.options = $.extend(self.options, opts);
    for (var key in data) {
      self[key] = data[key];
    }
  }(data, options);

  self.iconClass = function() {
    return Kadenze.FILE_ICONS_MAP[self.meta.type];
  };
}

